// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import Header from './Header'
import PopoverButton from './PopoverButton'
import SessionAPI from 'apis/SessionAPI'
import { withToastManager } from 'ui/toast';
import { useBillingModal } from '../../../contexts/BillingModalContext';


function SubscribeHeader(props) {
  const { showRenewalModal } = useBillingModal();
  const [subscribing, setSubscribing] = React.useState(false);

  const onRenew = React.useCallback(() => {
    showRenewalModal();
  }, [showRenewalModal]);

  const onSubscribe = React.useCallback(() => {
    setSubscribing(true);

    SessionAPI.createSessionWithLocation({}).catch((error)=>{
      props.toastManager.add(
        'There was an error subscribing. Please refresh and try again.', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 7000
      })
    }).then(()=>{
      setSubscribing(false);
    })
  }, [props.toastManager]);

  if ( props.isSeparatelyInvoiced )
    return null;

  return (
    <div style={{width:"100%", display: 'flex'}}>
      <div style={{flex: 1}}>
        <Header>{props.children}</Header>
      </div>
      <div style={{}}>
        <div className="subscribeButton">
          <PopoverButton
            name= {props.isSubscriptionOwner ? "Renew Subscription" :  "Start Subscription" }
            onClick={props.isSubscriptionOwner ? onRenew : onSubscribe }
            disabled={!!subscribing}
          >
            The project owner has granted you permission to edit
            this project, but you need an active subscription to edit.
          </PopoverButton>
        </div>
      </div>
    </div>
  );
}

export default withToastManager(SubscribeHeader);
